import gql from 'graphql-tag';

export const GET_STATE_VNM_STATS = gql`
  query GetStateVnmStats($planId: Int!) {
    plan(id: $planId) {
      id
      utilityAccounts {
        id
        utility {
          id
          state {
            id
            vnmSolarProjectsStatistics {
              expectedKwh
              numberOfProjects
              totalNumberOfMembers
            }
          }
        }
      }
    }
  }
`;

export const getStateVnmStatsMock = {
  plan: {
    id: 1,
    utilityAccounts: [
      {
        id: 1,
        utility: {
          id: 1,
          state: {
            id: 2,
            vnmSolarProjectsStatistics: {
              expectedKwh: 100000.34903,
              numberOfProjects: 34,
              totalNumberOfMembers: 5000,
            },
          },
        },
      },
    ],
  },
};
